// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2bVuY","clinicsSelect":"TableHeading_clinicsSelect__1g7Vm"};